import { render, staticRenderFns } from "./techSheets.vue?vue&type=template&id=1d24d7c9&scoped=true"
import script from "./techSheets.vue?vue&type=script&lang=js"
export * from "./techSheets.vue?vue&type=script&lang=js"
import style0 from "./techSheets.vue?vue&type=style&index=0&id=1d24d7c9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d24d7c9",
  null
  
)

export default component.exports